const seo = {
  pages: {
    home: {
      title: "Elite Dental Solutions | Zahnklinik",
      description:
        "Moderne Zahnklinik mit erfahrenem Team und patientenorientiertem Ansatz. Buchen Sie eine kostenlose Beratung und erhalten Sie einen individuellen Behandlungsplan.",
    },
    prices: {
      title: "Preise | Elite Dental Solutions",
      description:
        "Sehen Sie unsere Richtpreise für zahnmedizinische Leistungen. Kontaktieren Sie uns für einen individuellen Plan und ein genaues Angebot.",
    },
    "request-quote": {
      title: "Kostenlose Beratung | Elite Dental Solutions",
      description:
        "Senden Sie eine Anfrage und buchen Sie eine kostenlose Beratung. Unser Team meldet sich so schnell wie möglich zur Bestätigung der Details.",
    },
    "privacy-policy": {
      title: "Datenschutzerklärung | Elite Dental Solutions",
      description:
        "Erfahren Sie, wie Elite Dental Solutions personenbezogene Daten verarbeitet und schützt und welche Rechte Sie im Zusammenhang mit Datenschutz haben.",
    },
    "terms-of-service": {
      title: "Allgemeine Geschäftsbedingungen | Elite Dental Solutions",
      description:
        "Lesen Sie die Nutzungsbedingungen von Elite Dental Solutions, inklusive Terminen, Zahlungen, Verantwortlichkeiten und Bedingungen zur Website-Nutzung.",
    },
    "not-found": {
      title: "404 | Elite Dental Solutions",
      description: "Seite nicht gefunden.",
    },
    services: {
      implantology: {
        title: "Implantologie | Elite Dental Solutions",
        description:
          "Hochwertige Zahnimplantate mit präziser Planung und modernen Materialien. Stellen Sie Funktion und Sicherheit mit einer langfristigen Lösung wieder her.",
      },
      endodontics: {
        title: "Endodontie | Elite Dental Solutions",
        description:
          "Wurzelkanalbehandlung mit modernen Techniken und viel Sorgfalt. Schmerzen lindern und den natürlichen Zahn erhalten.",
      },
      "oral-surgery": {
        title: "Oralchirurgie | Elite Dental Solutions",
        description:
          "Oralchirurgische Eingriffe durch ein erfahrenes Team mit Fokus auf Sicherheit. Beratung, Behandlungsplan und Nachsorge.",
      },
      periodontology: {
        title: "Parodontologie | Elite Dental Solutions",
        description:
          "Zahnfleischgesundheit und Parodontalbehandlung für langfristige Mundgesundheit. Diagnose, Therapie und Prävention für gesundes Zahnfleisch.",
      },
      orthodontics: {
        title: "Kieferorthopädie | Elite Dental Solutions",
        description:
          "Kieferorthopädische Behandlung für gerade Zähne und eine harmonische Bisslage. Individuelle Planung und kontinuierliche Kontrolle.",
      },
      bonding: {
        title: "Bonding | Elite Dental Solutions",
        description:
          "Ästhetisches Bonding zur Korrektur kleiner Unregelmäßigkeiten in Form und Farbe. Schonende Optimierung Ihres Lächelns.",
      },
      prosthetics: {
        title: "Prothetik | Elite Dental Solutions",
        description:
          "Prothetische Lösungen wie Kronen, Brücken und Prothesen für Komfort und natürliche Ästhetik. Präzise Passform und langlebige Ergebnisse.",
      },
      "lip-filler": {
        title: "Lippenfiller | Elite Dental Solutions",
        description:
          "Lippenfiller-Behandlungen mit natürlichem Ergebnis und Blick für Proportionen. Beratung und individuell abgestimmter Ansatz.",
      },
      cariesology: {
        title: "Kariologie | Elite Dental Solutions",
        description:
          "Kariesdiagnostik und -behandlung mit schonenden Methoden und hochwertigen Materialien. Zahnhartsubstanz schützen und Ästhetik wiederherstellen.",
      },
      "teeth-whitening": {
        title: "Zahnaufhellung | Elite Dental Solutions",
        description:
          "Professionelle Zahnaufhellung in der Klinik oder zu Hause. Sichere Protokolle und sichtbare Ergebnisse für ein strahlenderes Lächeln.",
      },
      "dental-tourism": {
        title: "Zahntourismus | Elite Dental Solutions",
        description:
          "Zahntourismus in Bulgarien mit kompletter Organisation und hochwertiger Behandlung. Erhalten Sie Plan, Angebot und Unterstützung für Ihren Aufenthalt.",
      },
    },
  },
};

export default seo;

